package com.eladfinish.bible.contest.features.copyOptions

import androidx.compose.runtime.Immutable
import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt
import com.eladfinish.bible.contest.data.common.DocumentTextType
import com.eladfinish.bible.contest.features.copyOptions.model.CopyOptionsConfig
import com.eladfinish.bible.contest.features.copyOptions.model.CopyOptionsInput
import com.eladfinish.bible.contest.features.copyOptions.model.CopyOptionsOperation
import com.eladfinish.bible.contest.screens.search.ui.HighlightType

@Immutable
data class CopyOptionsState(
    val config: CopyOptionsConfig,
    val options: CopyOptions,
    val operation: CopyOptionsOperation,
    val input: CopyOptionsInput,
    val bookAndChapterForExport: String,
    val shouldAddParenthesisOnOtiotPasuk: Boolean,
    val documentTextType: DocumentTextType,
    val previewText: String,
    val isLoading: Boolean,
) : StateKt

sealed interface CopyOptionsAction : ActionKt {

    data class Init(
        val config: CopyOptionsConfig,
        val operation: CopyOptionsOperation,
        val input: CopyOptionsInput,
        val bookAndChapterForExport: String,
        val shouldAddParenthesisOnOtiotPasuk: Boolean,
        val documentTextType: DocumentTextType,
    ) : CopyOptionsAction

    data class SetIncludeExpression(
        val value: Boolean,
    ) : CopyOptionsAction

    data class SetIncludeNikud(
        val value: Boolean,
    ) : CopyOptionsAction

    data class SetIncludeTeamim(
        val value: Boolean,
    ) : CopyOptionsAction

    data class SetHandleGodNames(
        val value: Boolean,
    ) : CopyOptionsAction

    data class SetIncludeBookAndChapter(
        val value: Boolean,
    ) : CopyOptionsAction

    data class SetHighlightType(
        val value: HighlightType,
    ) : CopyOptionsAction

    data class SetRemoveVerseOrigin(
        val value: Boolean,
    ) : CopyOptionsAction

    data class SetCopyOnlyHighlights(
        val value: Boolean,
    ) : CopyOptionsAction

    data class SetRemoveDuplicates(
        val value: Boolean,
    ) : CopyOptionsAction

    data class SetSortResults(
        val value: Boolean,
    ) : CopyOptionsAction

    data object ConfirmCopyClicked : CopyOptionsAction
}

sealed interface CopyOptionsEffect : EffectKt {
    data object CloseDialog : CopyOptionsEffect

    data class SaveFile(
        val content: String,
    ) : CopyOptionsEffect
}
